<body class="ltr main-body leftmenu">
  <form autocomplete="off" novalidate>
    <!-- Main Content-->
    <div class="main-content side-content pt-0 ml-0">
      <div class="main-container container-fluid">
        <div class="inner-body">


          <div class="row row-sm add-form">
            <form autocomplete="off" class="p-0" novalidate [formGroup]="ExamSubjectForm ">
              <div class="col-lg-12 col-md-12">

                <div class="card custom-card">
                  <div class="card-body">

                    <div class="row">
                      <div class="col-md-8">
                        <div class=" d-flex align-items-center pl-3">
                          <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                          <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                User Subject Mapping
                              </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                              User Subject Mapping
                            </p>
                          </div>
                        </div>
                      </div>


                    </div>
                    <hr>
                    <div class="row clearfix">
                      <div class="col-sm-3">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width ">
                              <mat-label> User Name</mat-label>
                              <mat-select #select23 placeholder="LoginId" class="colorblack" formControlName="user">
                                <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                                  [displayMember]="'LoginFullName'" [array]="userList"
                                  (filteredReturn)="filteredUserList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredUserList"
                                  [value]="item.LoginId">{{item.LoginId}}
                                  - {{item.LoginFullName}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width ">
                              <mat-label>
                                {{'header.exam-subject.titleList.Course'
                                |
                                translate
                                }}
                              </mat-label>
                              <mat-select #select51 panelClass="custom-select-panel" class="colorblack"
                                formControlName="course" [displayMember]="'CoName'">
                                <mat-select-filter *ngIf="select51.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CoName'" [array]="CourseList"
                                  (filteredReturn)="filteredListCourse =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListCourse" [value]="item.CoCode "
                                  (click)="getList(item)">
                                  {{item.CoCode}} - {{item.CoName}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="ExamSubjectForm.controls['course'].touched && ExamSubjectForm.controls['course'].errors?.required">
                                Mandatory
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="ExamSubjectForm.controls['course'].touched && ExamSubjectForm.controls['course'].errors?.pattern">
                                Invalid
                              </mat-error>
                            </mat-form-field>

                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width ">
                              <mat-label>
                                {{'header.exam-subject.titleList.ExamName'
                                |
                                translate
                                }}
                              </mat-label>
                              <!-- <input matInput formControlName="CoGPAm" placeholder="CoGPAm"required> -->
                              <mat-select [disabled]="disableExam" #select52 class="colorblack" formControlName="exam">
                                <mat-select-filter *ngIf="select52.focused" [placeholder]="'Filter'"
                                  [displayMember]="'EmName'" [array]="examList"
                                  (filteredReturn)="filteredListExam =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListExam" [value]="item.EmId"
                                  (click)="get(item)">
                                  {{item.EmCode}} - {{item.EmName}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="ExamSubjectForm.controls['exam'].touched && ExamSubjectForm.controls['exam'].errors?.required">
                                Mandatory
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="ExamSubjectForm.controls['exam'].touched && ExamSubjectForm.controls['exam'].errors?.pattern">
                                Invalid
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <!-- this is was disabled is now being enabled -->
                      <div class="col-sm-3" *ngIf="Branch">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width ">
                              <mat-label>
                                Branch/Stream
                              </mat-label>

                              <mat-select #select53 class="colorblack" formControlName="strId">
                                <mat-select-filter *ngIf="select53.focused" [placeholder]="'Filter'"
                                  [displayMember]="'item.StrId'" [array]="BranchList"
                                  (filteredReturn)="filteredListBranch =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListBranch" [value]="item.StrId"
                                  (onSelectionChange)="getStr(item)" (click)="getStr(item)">
                                  {{item.StrName}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-12">
                        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
                          <!-- This is the tree node template for leaf nodes -->
                          <!-- There is inline padding applied to this node using styles.
                                This padding value depends on the mat-icon-button width. -->
                          <mat-tree-node class="borderMain" *matTreeNodeDef="let node" matTreeNodeToggle>

                            <!-- <mat-tree-node class="" *matTreeNodeDef="let node" matTreeNodeToggle> -->
                            <div class="setBorder"></div>
                            <a title="Edit" class="btn-floating m1"><i aria-hidden="true"> {{node.EsType}}</i></a>

                            <a class="m1">{{node.EsCode}} - {{node.EsName}}</a>
                            <!-- subject checkbox -->
                            <div formArrayName="subjectArray">

                              <mat-checkbox class="checklist-leaf-node m1"
                                [checked]="checklistSelection.isSelected(node)"
                                (change)="checklistSelection.toggle(node);"></mat-checkbox>
                            </div>

                          </mat-tree-node>
                          <!-- This is the tree node template for expandable nodes -->
                          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                            <!-- <div class="mat-tree-node"> -->
                            <div class="mat-tree-node borderMain">
                              <div class="setBorder"></div>
                              <a title="Edit" class="btn-floating m1"><i aria-hidden="true"> {{node.EsType}}</i></a>
                              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.EsName">
                                <mat-icon class="mat-icon-rtl-mirror">
                                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}} </mat-icon>
                              </button>
                              {{node.EsCode}} - {{node.EsName}}
                              <!-- group checkbox -->
                              <div formArrayName="groupArray">
                                <mat-checkbox class="checklist-leaf-node m1" [checked]="descendantsAllSelected(node)"
                                  [indeterminate]="descendantsPartiallySelected(node)"
                                  (change)="onCheckboxChanged($event,node)"
                                  (change)="todoItemSelectionToggle(node)"></mat-checkbox>
                              </div>

                            </div>
                            <!-- There is inline padding applied to this div using styles.
                                      This padding value depends on the mat-icon-button width.  -->
                            <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group"
                              class="borderMain">
                              <ng-container matTreeNodeOutlet></ng-container>
                            </div>
                          </mat-nested-tree-node>
                        </mat-tree>
                      </div>
                      <div class="col-sm-12">
                        <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                          (click)="save()">
                          <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                            Save
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </form>
</body>